import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  BrowserRouter,
} from "react-router-dom";

import { AuthProvider } from "./AuthnContext";
import SecureRouter from "./SecureRouter";
import axios from "axios";
import PrivacyPolicy from "./PrivacyPolicy";

axios.defaults.baseURL = "https://api.ankiety.coms.pl";
// axios.defaults.baseURL = "https://localhost:7266";

axios.interceptors.request.use(
  (request) => {
    return request;
  },
  (error) => {
    window.location.href = "/error";
  }
);

// Floating Privacy Policy Button
function PrivacyPolicyButton() {
  return (
    <a
      href="/privacy-policy"
      className="privacy-policy-button"
      title="Polityka Prywatności"
    >
      Polityka Prywatności
    </a>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <SecureRouter />
      <PrivacyPolicyButton />
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
